module.exports = __webpack_public_path__ + "assets/img/reminder-share-2.bc9f5efa.png";